import { atom } from "recoil";

export const selectedRowsAtom = atom({
  key: "selectedRowsState",
  default: [],
});
